import React from 'react';
import { Box } from '@mui/material';
import { glintDotSx } from '../theme/tokens';

/** A small square status/flag mark — replaces the old Stargate-chevron
 * glyph, which was this app's second design pass's signature motif and is
 * retired along with it (see DESIGN.md). EVE's own client uses a plain
 * small square for exactly this job (the Overview's flag column, a
 * selected-row marker) — a flat colored tile, not a wedge with a glow.
 * Kept as the same component name/API (`color`, `size`, `pulse`, `sx`)
 * everywhere it's already imported, so this one file reskins every panel
 * header, badge, and nav tick in the app at once. `pulse` is reserved for
 * genuinely live state (a character online right now), not decoration. */
const Chevron: React.FC<{ color: string; size?: number; pulse?: boolean; sx?: object }> = ({
  color,
  size = 7,
  pulse = false,
  sx,
}) => (
  <Box
    aria-hidden
    sx={{
      width: size,
      height: size,
      flexShrink: 0,
      backgroundColor: color,
      borderRadius: '1px',
      ...(pulse ? glintDotSx(color) : {}),
      ...sx,
    }}
  />
);

export default Chevron;
